import React from 'react';
import PropTypes from 'prop-types';
import './PageLoaderSpinner.scss';

const PageLoaderSpinner = ({ classNames, withOverlay }) => {
  const styles = withOverlay ? {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '50%',
  } : {};

  return (
    <div className="page-loader__spinner">
      <svg viewBox="25 25 50 50" className={classNames} style={styles}>
        <circle cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
      </svg>
    </div>
  );
};

PageLoaderSpinner.propTypes = {
  classNames: PropTypes.string,
  withOverlay: PropTypes.bool,
};

PageLoaderSpinner.defaultProps = {
  classNames: '',
  withOverlay: false,
};

export default PageLoaderSpinner;
